import PropTypes from 'prop-types';
import React from 'react';
import SubIcon from '../components/SubIcon';
import FootballMatchEventIcon from 'modules/Football/components/svg/FootballMatchEventIcon';


export default function FootballPlayer(props) {
  let subOn;
  let subOff;
  if(props.player.starting){
    if(props.player.sub.subbedOff){
      subOn = 'Sub Off';
    }
  }else{
    if(props.player.sub.subbedOn){
      subOn = 'Sub On';
    }
    if(props.player.sub.subbedOff){
      subOff = 'Sub Off';
    }
  }

  const cards = [];
  if(props.player.yellowCardTime){
    cards.push('Yellow Card');
  }
  if(props.player.secondYellowCardTime){
    cards.push('Second Yellow Card');
  }
  if(props.player.redCardTime){
    cards.push('Red Card');
  }

  return (
    <div>
      <section className="footballPlayerRow">
        <div className="footballPlayerNumber">
          {props.player.shirt_number}
        </div>
        <div className="footballPlayerNameSubCard">
          <span className="playerName">{props.player.name}</span>
          {subOn && <SubIcon time = {props.player.sub.onTime} type = {subOn}/>}
          {subOff && <SubIcon time = {props.player.sub.offTime} type = {subOff}/>}
          <span className="cardIcon">
            {cards && cards.map((card,index) => <FootballMatchEventIcon key={index} type={card}/>)}
          </span>
        </div>
      </section>
      <div className="rowUnderLine"></div>
    </div>
  );
}

FootballPlayer.propTypes = {
  player : PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./modules/Football/components/FootballPlayer.js